var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlinedSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3957 2C16.4392 2 20.5326 6.032 20.5326 11C20.5326 15.968 16.4392 20 11.3957 20C6.35211 20 2.25879 15.968 2.25879 11C2.25879 6.032 6.35211 2 11.3957 2ZM11.3957 18C15.3215 18 18.5021 14.867 18.5021 11C18.5021 7.132 15.3215 4 11.3957 4C7.46884 4 4.28921 7.132 4.28921 11C4.28921 14.867 7.46884 18 11.3957 18ZM20.0097 18.071L22.8817 20.899L21.4452 22.314L18.5742 19.485L20.0097 18.071Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedSearchIcon);
export default __webpack_public_path__ + "static/media/outlined-search-icon.88539bbc4a7d68449efcf048f7406313.svg";
export { ForwardRef as ReactComponent };